import { Star } from "lucide-react";
import { testimonials } from "../../mock";

const TestimonialsSection = () => {
  return (
    <section className="testimonials">
      <div className="wrap">
        <div className="section-head reveal">
          <div>
            <div className="kicker">07 — Client feedback</div>
            <h2>
              Built on
              <br />
              <span className="accent">trust.</span>
            </h2>
          </div>
          <div className="testimonials-rating">
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={14} strokeWidth={1.4} fill="currentColor" />
              ))}
            </div>
            <p>5.0 rating across 9 Google reviews for NK Design Group, now part of ODDA.</p>
          </div>
        </div>
        <div className="quote-grid reveal">
          {testimonials.map((t, i) => (
            <blockquote className="quote" key={i}>
              <span className="quote-mark">“</span>
              <p>{t.quote}</p>
              <cite>— {t.author}</cite>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
